import Radio from "backbone.radio";
import { useEffect } from "react";
import { unescape } from "lodash-es";

import { RESET_RECON_STORE } from "common/actions/reconciliation";
import { AuthRoute, useRouteMatch, useParams, useQueryParameters } from "extensions/react-router";

import { parseDisplayOptions } from "./helpers";
import { Reconciliation } from "./reconciliation";

export function Reconciliation3Router() {
    const { url } = useRouteMatch();
    return <AuthRoute path={`${url}/reconciliation3/:options?/:qualifiers?`} component={ReconciliationComponent} />;
}

export function ReconciliationRouter() {
    const { url } = useRouteMatch();
    return <AuthRoute path={`${url}/reconciliation/:options?/:qualifiers?`} component={ReconciliationComponent} />;
}

function ReconciliationComponent() {
    const { options: displayOptions, qualifiers } = useParams();
    const queryParams = useQueryParameters();

    useEffect(() => {
        // On page load, the default suggested date range will show the last 3 full months + the current month to date
        try {
            RESET_RECON_STORE({
                ...parseDisplayOptions(displayOptions),
                qualifiers: qualifiers || "",
                filters: unescape(queryParams.q || "")
            });
        } catch {
            RESET_RECON_STORE();
        }

        Radio.channel("main").request(
            "show:app:view",
            <Reconciliation options={{
                displayOptions,
                qualifiers,
                queryParams
            }}
            />,
            {
                name: "Reconciliation",
                waitForAttach: true,
                asyncHeaderBar(cb) {
                    return cb({
                        name: "Reconciliation",
                        dates: queryParams.dates || "now-2w/d_now"
                    });
                }
            }
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayOptions, qualifiers, queryParams.q, queryParams.dates]);

    return null;
}
